// extracted by mini-css-extract-plugin
export default {"container":"l2-z","list":"m2-z"};